module.exports = __webpack_public_path__ + "assets/img/ddbes_check.d832d3d7.png";